// import * as vueRouter from 'vue-router';
import { createRouter, createWebHashHistory } from 'vue-router';
const Propaganda = () => import('@/views/Propaganda/index.vue');
import routers from './routers';
const routes = [
  {
    path: '/',
    redirect: 'Propaganda',
  },

  // {
  //   path: '/propaganda',
  //   name: 'Propaganda',
  //   component: Propaganda,
  //   meta: {
  //     position: 'relative',
  //     requireAuth: false,
  //   },
  // },
  {
    path: '/:pathMatch(.*)*',
    component: Propaganda,
    meta: {
      position: 'relative',
      requireAuth: false,
    },
  },

  ...routers,
];

// export default router;
export default createRouter({
  history: createWebHashHistory(),
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});
